import React from 'react';
import { Download } from 'lucide-react';
import { Button } from '../../ui/button';
import { formatPrice, formatDate } from '../utils';

const PackName = ({ name }) => <span>{name}</span>;

const PaymentsView = ({ reservations, stats }) => {
  const paymentRows = reservations.filter(r => r.payment_status === 'paid' || r.payment_status === 'refunded');
  const totalRefunded = reservations.filter(r => r.payment_status === 'refunded').reduce((sum, r) => sum + (r.monthly_price || 0), 0);

  const statusBadge = (status) => {
    if (status === 'refunded') return <span className="px-2 py-1 rounded-full text-xs font-medium bg-orange-500/20 text-orange-400">Remboursé</span>;
    return <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-500/20 text-green-400">Payé</span>;
  };

  return (
<div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold text-white">Paiements</h2>
        <Button variant="outline" size="sm" className="border-slate-700 text-slate-300">
          <Download className="w-4 h-4 mr-2" />
          Export
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-slate-900 rounded-xl border border-slate-800 p-5">
          <p className="text-sm text-slate-400 mb-1">Paiements ce mois</p>
          <p className="text-2xl font-bold text-green-400">{formatPrice(stats?.monthly_revenue || 0)}</p>
        </div>
        <div className="bg-slate-900 rounded-xl border border-slate-800 p-5">
          <p className="text-sm text-slate-400 mb-1">En attente</p>
          <p className="text-2xl font-bold text-yellow-400">{formatPrice(stats?.pending_payments || 0)}</p>
        </div>
        <div className="bg-slate-900 rounded-xl border border-slate-800 p-5">
          <p className="text-sm text-slate-400 mb-1">Remboursés</p>
          <p className="text-2xl font-bold text-orange-400" data-testid="refunded-total">{formatPrice(totalRefunded)}</p>
        </div>
        <div className="bg-slate-900 rounded-xl border border-slate-800 p-5">
          <p className="text-sm text-slate-400 mb-1">Échecs</p>
          <p className="text-2xl font-bold text-red-400">{stats?.failed_payments || 0}</p>
        </div>
      </div>

      <div className="bg-slate-900 rounded-xl border border-slate-800 overflow-hidden">
        <div className="overflow-x-auto">
        <table className="w-full min-w-[900px]">
          <thead className="bg-slate-800/50">
            <tr>
              <th className="text-left px-4 py-3 text-xs font-medium text-slate-400">Client</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-slate-400">Pack</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-slate-400">Montant</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-slate-400">Type</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-slate-400">Date</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-slate-400">Statut</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800">
            {paymentRows.map((res) => (
              <tr key={res.id} className="hover:bg-slate-800/30">
                <td className="px-4 py-3">
                  <p className="text-sm text-white">{res.customer?.firstName} {res.customer?.lastName}</p>
                </td>
                <td className="px-4 py-3 text-sm text-slate-300"><PackName name={res.pack_name} /></td>
                <td className="px-4 py-3 text-sm text-white font-medium">{formatPrice(res.monthly_price + res.caution)}</td>
                <td className="px-4 py-3 text-sm text-slate-400">{res.payment_status === 'refunded' ? 'Remboursement' : 'Premier paiement'}</td>
                <td className="px-4 py-3 text-sm text-slate-400">{formatDate(res.payment_status === 'refunded' ? res.cancelled_at : res.created_at)}</td>
                <td className="px-4 py-3" data-testid={`payment-status-${res.id}`}>
                  {statusBadge(res.payment_status)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
};

export default PaymentsView;
